import CardLabel from "@/components/_Molecules/_NewComponents/CardLabel";
import { RootState } from "@/services/redux/store";
import { EdgeType } from "@/utils/types/requests";
import { DataGrid, Pagination } from "@abtasty/design-system";
import { useQuery } from "@apollo/client";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getTopProductsColumns } from "./columns";
import { PRODUCT_BY_PAGE } from "./enums";
import { formatDataForTopProducts } from "./formatters";
import { GET_TOP_PRODUCTS } from "./requests";
import { ITopProducts } from "./types";
import { useLocale } from "@/context/LocaleProvider";

const TopProducts: React.FC<ITopProducts> = ({
  dateRange,
  experienceType,
  devices,
  dateRangeIsSet,
  differenceDays,
  analyticsName,
  filterCategoryIds,
}) => {
  const { t } = useTranslation();
  const siteId = useSelector((state: RootState) => state.site.siteId);
  const { locale } = useLocale();
  const currency = useSelector((state: RootState) => state.catalog.currency);
  const [topProducts, setTopProducts] = useState<
    Array<{ id: string | number } & Dic<any>>
  >([]);

  const { loading: loadingTopProducts } = useQuery(GET_TOP_PRODUCTS, {
    variables: {
      siteId: parseInt(siteId),
      startDate: dayjs(dateRange?.from).format("YYYY-MM-DD"),
      endDate: dayjs(dateRange?.to).format("YYYY-MM-DD"),
      segments: isEmpty(filterCategoryIds)
        ? [`potions;${experienceType};${analyticsName};all`]
        : filterCategoryIds?.map(
            (id: string) =>
              `potions;${experienceType};${analyticsName};${id};all`
          ),
      query: "CONVERSION_RATE_BY_DAY",
      devices: devices,
      first: PRODUCT_BY_PAGE,
    },
    skip:
      !dateRangeIsSet ||
      isEmpty(analyticsName) ||
      isEmpty(experienceType) ||
      isEmpty(devices),
    onCompleted: (res: Dic<any>) => {
      setTopProducts(
        formatDataForTopProducts(
          res?.itemMonitor?.edges?.map((edge: EdgeType) => edge.node) ?? [],
          locale,
          currency
        )
      );
    },
  });

  if (isEmpty(topProducts)) return <div />;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <CardLabel label={t("top_products", { x: 25, by: t("displays") })} />
      </div>
      <div
        style={{
          backgroundColor: "var(--primary-default-bg-norm)",
          borderRadius: 4,
          width: "100%",
          border: "1px solid var(--primary-default-sk-norm)",
        }}
      >
        <DataGrid
          data={differenceDays === 0 ? [] : topProducts}
          columns={getTopProductsColumns(t)}
          isLoading={loadingTopProducts}
        />
      </div>
    </div>
  );
};

export default TopProducts;
